var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6699 27.3994V9.93255C13.6699 9.21025 13.6699 8.8491 13.8013 8.55618C13.9172 8.29798 14.1037 8.07781 14.3393 7.9211C14.6066 7.74333 14.9629 7.68396 15.6754 7.56521L28.8754 5.36521C29.8368 5.20497 30.3175 5.12485 30.6922 5.264C31.021 5.38612 31.2966 5.61958 31.4711 5.9238C31.6699 6.27048 31.6699 6.75784 31.6699 7.73256V24.3994M13.6699 27.3994C13.6699 29.8847 11.6552 31.8995 9.16992 31.8995C6.68464 31.8995 4.66992 29.8847 4.66992 27.3994C4.66992 24.9142 6.68464 22.8994 9.16992 22.8994C11.6552 22.8994 13.6699 24.9142 13.6699 27.3994ZM31.6699 24.3994C31.6699 26.8847 29.6552 28.8994 27.1699 28.8994C24.6846 28.8994 22.6699 26.8847 22.6699 24.3994C22.6699 21.9142 24.6846 19.8994 27.1699 19.8994C29.6552 19.8994 31.6699 21.9142 31.6699 24.3994Z",
    stroke: "#AFB6B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.d93a32f0b8bc2db34c16dca8baf56461.svg";
export { ForwardRef as ReactComponent };